import { useAppSelector, useAppDispatch } from '@/store/hooks'
import { selectProjectById } from '@/store/projects/projectsSelectors'
import { unpublishProjectSaga } from '@/store/projects/projectsSlice'
import { openConfirmDialog, setOpenModal } from '@/store/ui/uiSlice'
import Modal from '@/components/modals/Modal/Modal'
import Button from '@/components/ui/Button/Button'
import CopyField from '@/components/ui/CopyField/CopyField'
import IconButton from '@/components/ui/IconButton/IconButton'
import IconClose from '@/assets/icons/icon-close.svg?react'
import IconLogo from '@/assets/icons/img-logo.svg?react'
import { TextH2, TextNorm } from '@/components/ui/Text'
import css from './PublishProjectModal.module.css'

interface Props {
    projectId: string
    onClose: () => void
}

const PublishProjectModal = ({ projectId, onClose }: Props) => {
    const dispatch = useAppDispatch()
    const project = useAppSelector(state => selectProjectById(state, projectId))

    const shareId = project?.publicShareId
    const link = shareId ? `${window.location.origin}/share/${shareId}` : ''

    const handleUnpublish = () => {
        dispatch(openConfirmDialog({
            title: 'Unpublish project',
            text: 'Anyone with the current link will lose access. A new link is generated if you publish again.',
            confirmButtonTitle: 'Unpublish',
            confirmButtonAction: () => {
                dispatch(unpublishProjectSaga(projectId))
                dispatch(setOpenModal(null))
            }
        }))
    }

    return (
        <Modal onClose={onClose} maxWidth={416}>
            <div className={css.buttons}>
                <IconButton icon={<IconClose />} onClick={onClose} />
            </div>

            <div className={css.logo}>
                <IconLogo />
            </div>

            <div className={css.text}>
                <TextH2>Share project</TextH2>
                <TextNorm className={css.desc}>
                    Anyone with the link can view this project's tasks, no sign-in needed. It's read-only — task descriptions and comments aren't included.
                </TextNorm>
            </div>

            <div className={css.actions}>
                <CopyField value={link} toastMessage="Link copied" />
                <Button type="white" size="medium" title="Unpublish" onClick={handleUnpublish} />
            </div>
        </Modal>
    )
}

export default PublishProjectModal
